// @ts-nocheck -- see CLAUDE.md's "TypeScript checking on assets/*.js" section for why
(function () {
  window.OXTAK_I18N = window.OXTAK_I18N || {};
  var OXN_I18N = {
    en: {
      news: {
        hero: {
          h1span: "News",
          sub: "News about Oxtak, collated specially for you.",
        },
        filters: {
          all: "All",
          tech: "Tech media",
          blogs: "Blogs",
          social: "Social",
          video: "Video",
          news: "News",
        },
        search: { placeholder: "Search mentions…" },
        empty: "No mentions match your search.",
      },
    },
    zh: {
      news: {
        hero: { h1span: "新闻", sub: "有关 Oxtak 的新闻，专为您精心整理。" },
        filters: {
          all: "全部",
          tech: "科技媒体",
          blogs: "博客",
          social: "社交媒体",
          video: "视频",
          news: "新闻",
        },
        search: { placeholder: "搜索提及…" },
        empty: "没有符合您搜索的内容。",
      },
    },
    es: {
      news: {
        hero: {
          h1span: "Noticias",
          sub: "Noticias sobre Oxtak, recopiladas especialmente para ti.",
        },
        filters: {
          all: "Todo",
          tech: "Medios tecnológicos",
          blogs: "Blogs",
          social: "Social",
          video: "Video",
          news: "Noticias",
        },
        search: { placeholder: "Buscar menciones…" },
        empty: "Ninguna mención coincide con tu búsqueda.",
      },
    },
    fr: {
      news: {
        hero: {
          h1span: "Actualités",
          sub: "Actualités sur Oxtak, rassemblées spécialement pour vous.",
        },
        filters: {
          all: "Tout",
          tech: "Médias tech",
          blogs: "Blogs",
          social: "Réseaux sociaux",
          video: "Vidéo",
          news: "Actualités",
        },
        search: { placeholder: "Rechercher des mentions…" },
        empty: "Aucune mention ne correspond à votre recherche.",
      },
    },
    ru: {
      news: {
        hero: {
          h1span: "Новости",
          sub: "Новости об Oxtak, специально подобранные для вас.",
        },
        filters: {
          all: "Все",
          tech: "Технологические СМИ",
          blogs: "Блоги",
          social: "Соцсети",
          video: "Видео",
          news: "Новости",
        },
        search: { placeholder: "Поиск упоминаний…" },
        empty: "По вашему запросу ничего не найдено.",
      },
    },
    ja: {
      news: {
        hero: {
          h1span: "ニュース",
          sub: "Oxtakに関するニュースをまとめてお届けします。",
        },
        filters: {
          all: "すべて",
          tech: "テックメディア",
          blogs: "ブログ",
          social: "ソーシャル",
          video: "動画",
          news: "ニュース",
        },
        search: { placeholder: "メンションを検索…" },
        empty: "検索条件に一致するメンションはありません。",
      },
    },
    ko: {
      news: {
        hero: {
          h1span: "뉴스",
          sub: "Oxtak에 관한 뉴스를 특별히 모아드렸습니다.",
        },
        filters: {
          all: "전체",
          tech: "테크 미디어",
          blogs: "블로그",
          social: "소셜",
          video: "동영상",
          news: "뉴스",
        },
        search: { placeholder: "언급 검색…" },
        empty: "검색 결과가 없습니다.",
      },
    },
    vi: {
      news: {
        hero: {
          h1span: "Tin tức",
          sub: "Tin tức về Oxtak, được tổng hợp đặc biệt dành cho bạn.",
        },
        filters: {
          all: "Tất cả",
          tech: "Truyền thông công nghệ",
          blogs: "Blog",
          social: "Mạng xã hội",
          video: "Video",
          news: "Tin tức",
        },
        search: { placeholder: "Tìm kiếm đề cập…" },
        empty: "Không có đề cập nào phù hợp với tìm kiếm của bạn.",
      },
    },
  };
  Object.keys(OXN_I18N).forEach(function (code) {
    window.OXTAK_I18N[code] = window.OXTAK_I18N[code] || {};
    window.OXTAK_I18N[code].news = OXN_I18N[code].news;
  });
  var TYPE_LABELS = {
    tech_media: "Tech media",
    news: "News",
    blog: "Blog",
    social_x: "X / Twitter",
    social_linkedin: "LinkedIn",
    social_facebook: "Facebook",
    social_reddit: "Reddit",
    social_instagram: "Instagram",
    social_tiktok: "TikTok",
    video_youtube: "YouTube",
  };
  var ITEMS_PER_PAGE = 20;
  var activeFilter = "all";
  var currentPage = 1;
  var currentFiltered = [];
  var timelineEl = document.getElementById("oxnTimeline");
  var paginationEl = document.getElementById("oxnPagination");
  var emptyStateEl = document.getElementById("oxnEmptyState");
  var searchInput = document.getElementById("oxnSearchInput");
  var LANG_BCP47 = { JP: "ja", JA: "ja", ZH: "zh", KO: "ko" };
  function esc(s) {
    return window.oxtakEscapeHtml(s);
  }
  function setFilter(type, btn) {
    activeFilter = type;
    document.querySelectorAll(".oxn-filter-btn").forEach(function (b) {
      b.classList.remove("active");
    });
    if (btn) btn.classList.add("active");
    applyFilters();
  }
  function applyFilters() {
    var q = (searchInput.value || "").toLowerCase();
    currentFiltered = (window.MENTIONS || []).filter(function (m) {
      var matchType =
        activeFilter === "all" ||
        m.source_type === activeFilter ||
        (activeFilter === "social" && m.source_type.indexOf("social_") === 0);
      var matchQ =
        !q ||
        m.title.toLowerCase().indexOf(q) > -1 ||
        m.snippet.toLowerCase().indexOf(q) > -1 ||
        m.source.toLowerCase().indexOf(q) > -1;
      return matchType && matchQ;
    });
    currentFiltered.sort(function (a, b) {
      return (b.date || "").localeCompare(a.date || "");
    });
    currentPage = 1;
    emptyStateEl.style.display = currentFiltered.length ? "none" : "block";
    render();
  }
  function groupByMonth(mentions) {
    var groups = {};
    mentions.forEach(function (m) {
      var key = m.date ? m.date.slice(0, 7) : "undated";
      var label =
        key === "undated"
          ? "Undated"
          : new Date(key + "-01").toLocaleDateString("en-US", {
              month: "long",
              year: "numeric",
            });
      if (!groups[key]) groups[key] = { label: label, items: [] };
      groups[key].items.push(m);
    });
    return Object.keys(groups)
      .sort(function (a, b) {
        return b.localeCompare(a);
      })
      .map(function (k) {
        return groups[k];
      });
  }
  function buildCard(m) {
    var card = document.createElement("a");
    card.className = "oxn-mention-card";
    card.href = /^https?:\/\//i.test(m.url) ? m.url : "#";
    card.target = "_blank";
    card.rel = "noopener noreferrer";
    if (m.language && m.language !== "EN") {
      card.lang = LANG_BCP47[m.language] || m.language.toLowerCase();
      card.setAttribute("translate", "no");
    }
    var langTag =
      m.language && m.language !== "EN"
        ? '<span class="oxn-lang-tag">' + esc(m.language) + "</span>"
        : "";
    card.innerHTML =
      '<div class="oxn-card-header"><span class="oxn-source-badge">' +
      esc(TYPE_LABELS[m.source_type] || m.source_type) +
      "</span>" +
      langTag +
      "</div>" +
      '<div class="oxn-card-title">' +
      esc(m.title) +
      "</div>" +
      '<div class="oxn-card-snippet">' +
      esc(m.snippet) +
      "</div>" +
      '<div class="oxn-card-footer"><span class="oxn-card-source">' +
      esc(m.source) +
      '</span><span class="oxn-card-arrow">Read more →</span></div>';
    return card;
  }
  function renderTimeline(mentions) {
    var groups = groupByMonth(mentions);
    timelineEl.innerHTML = "";
    var frag = document.createDocumentFragment();
    groups.forEach(function (g) {
      var group = document.createElement("div");
      group.className = "oxn-timeline-group";
      var monthLabel = document.createElement("div");
      monthLabel.className = "oxn-timeline-month";
      monthLabel.textContent = g.label;
      group.appendChild(monthLabel);
      var grid = document.createElement("div");
      grid.className = "oxn-card-grid";
      g.items.forEach(function (m) {
        grid.appendChild(buildCard(m));
      });
      group.appendChild(grid);
      frag.appendChild(group);
    });
    timelineEl.appendChild(frag);
  }
  function render() {
    var totalPages = Math.max(
      1,
      Math.ceil(currentFiltered.length / ITEMS_PER_PAGE),
    );
    currentPage = Math.min(currentPage, totalPages);
    var start = (currentPage - 1) * ITEMS_PER_PAGE;
    renderTimeline(currentFiltered.slice(start, start + ITEMS_PER_PAGE));
    renderPagination(totalPages);
  }
  function goToPage(page) {
    currentPage = page;
    render();
    timelineEl.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  function renderPagination(totalPages) {
    paginationEl.innerHTML = "";
    if (totalPages <= 1) return;
    var range = [];
    if (totalPages <= 7) {
      for (var i = 1; i <= totalPages; i++) range.push(i);
    } else {
      range.push(1);
      if (currentPage > 3) range.push("...");
      for (
        var j = Math.max(2, currentPage - 1);
        j <= Math.min(totalPages - 1, currentPage + 1);
        j++
      )
        range.push(j);
      if (currentPage < totalPages - 2) range.push("...");
      range.push(totalPages);
    }
    var frag = document.createDocumentFragment();
    var prev = document.createElement("button");
    prev.className = "oxn-pg-btn oxn-pg-arrow";
    prev.innerHTML = '&lsaquo; <span class="oxn-pg-label">Previous</span>';
    prev.disabled = currentPage === 1;
    prev.addEventListener("click", function () {
      goToPage(currentPage - 1);
    });
    frag.appendChild(prev);
    range.forEach(function (p) {
      if (p === "...") {
        var ell = document.createElement("span");
        ell.className = "oxn-pg-ellipsis";
        ell.textContent = "…";
        frag.appendChild(ell);
      } else {
        var btn = document.createElement("button");
        btn.className =
          "oxn-pg-btn" + (p === currentPage ? " oxn-pg-active" : "");
        btn.textContent = String(p);
        btn.addEventListener("click", function () {
          goToPage(p);
        });
        frag.appendChild(btn);
      }
    });
    var next = document.createElement("button");
    next.className = "oxn-pg-btn oxn-pg-arrow";
    next.innerHTML = '<span class="oxn-pg-label">Next</span> &rsaquo;';
    next.disabled = currentPage === totalPages;
    next.addEventListener("click", function () {
      goToPage(currentPage + 1);
    });
    frag.appendChild(next);
    paginationEl.appendChild(frag);
  }
  document.querySelectorAll(".oxn-filter-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      setFilter(btn.getAttribute("data-filter"), btn);
    });
  });
  if (searchInput) searchInput.addEventListener("input", applyFilters);
  applyFilters();
  window.applyLocale(window.getOxtakLocale());
})();
